import * as React from "react";
import { DynLabel, AppLabel } from "@@services/i18nservice";
import { MegaMenuPanelSection } from "./megamenupanel.section";
import type { IMegaMenuRootProps } from "./megamenuroot";
import type { IMegaMenuData, IMegaMenuEntry, IMegaMenuFavorite } from "./definitions";

import "./megamenupanel.less";

export interface IMegaMenuPanelProps extends IMegaMenuRootProps {
    dataManager: IMegaMenuData;
    entry: IMegaMenuEntry;
    onBack?: () => void;
    onHide?: () => void;
    refresh?: () => void;
    onToggleFavorites: (items: IMegaMenuFavorite[]) => void;
}

export interface IMegaMenuPanelState {

}

export class MegaMenuPanel extends React.Component<IMegaMenuPanelProps, IMegaMenuPanelState> {
    componentDidMount() {
        this.props.refresh?.();
    }
    
    render() {
        return <div className="megamenu-panel">
            <h2 className="entry-title">
                {this.props.onBack ? <div className="backbtn clickable" onClick={(arg) => {
                    arg.preventDefault();
                    this.props.onBack();
                }}><i className="inwink-arrow-right" /></div> : null}
                {this.props.entry.icon ? <div className="icon"><i className={this.props.entry.icon} /></div> : null}
                {this.props.entry.label ? <DynLabel className="entry-label" i18n={this.props.entry.label} /> : null }
                {this.props.entry.title ? <AppLabel className="entry-label" i18n={this.props.entry.title} /> : null }
            </h2>            
            <div className="megamenu-panel-sections">
                {this.props.entry.sections.map((s, idx) => {
                    return <MegaMenuPanelSection key={s.key || "section" + idx} {...this.props} section={s} />;
                })}
            </div>
        </div>;
    }
}